import { render, staticRenderFns } from "./MyPermit.vue?vue&type=template&id=fe01d614&lang=pug&"
import script from "./MyPermit.vue?vue&type=script&lang=js&"
export * from "./MyPermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports